import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  managments: []
}

const mutations = {  
  SET_MANAGMENTS (state, payload) {
    state.managments = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  managmentList: (context, id) => {
    return Vue.http.get(`${env.API}/api/managment`)    
      .then((response) => {        
        context.commit('SET_MANAGMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getManagments: (state) => state.managments
}

export const managment = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/managment.js